module.exports = __webpack_public_path__ + "img/partner_53.a336bb83.png";